import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import Constants from "../../../../constants";
import _ from "lodash";
import {
  CLEARING_FEE,
  MAX_CLEARING,
  STAMP_DUTY,
  STAMP_DUTY_MAX,
  STAMP_DUTY_WARRANT,
  STAMP_DUTY_WARRANT_MAX,
} from "../../../../utils/Helper";

const actionData = [
  Constants.TRANSFER_IN,
  Constants.TRANSFER_OUT,
  Constants.CASH_IN,
  Constants.CASH_OUT,
  Constants.BUY_IN,
  Constants.SELL_OUT,
];

function AddNewMargin({
  setValue,
  reset,
  getValues,
  show,
  handleClose,
  register,
  handleSubmit,
  watch,
  isEdit,
}) {
  const actionType = watch("action_type");
  const stockQuantity = watch("stock_quantity");
  const stock_price = watch("stock_price");
  const brokerage_under_rate = watch("brokerage_under_rate");
  const brokerage_over_rate = watch("brokerage_over_rate");
  const stock_code = watch("stock_code");
  const stock_mof = watch("stock_mof");
  const min_brokerage = watch("min_brokerage");
  const clearing_fee_rate = watch("clearing_fee_rate");
  const max_clearing_fee = watch("max_clearing_fee");
  const sst = watch("sst");
  useEffect(() => {
    if (actionType === Constants.BUY_IN || action_type === Constants.SELL_OUT) {
      const marginAmount =
        parseFloat(stockQuantity) * 100 * parseFloat(stock_price) * (parseFloat(stock_mof) / 100);
      setValue("amount", newAmount());
      setValue("margin_amount", _.isNaN(marginAmount) ? 0 : marginAmount);
    }
  }, [actionType, stockQuantity, stock_price, stock_code, stock_mof]);
  const newAmount = () => {
    let osAmount = 0;
    if (actionType === Constants.BUY_IN || actionType === Constants.SELL_OUT) {
      let qty = actionType === Constants.SELL_OUT ? Math.abs(stockQuantity) * -1 : Math.abs(stockQuantity);
      let grossAmount = parseFloat(qty * 100 * stock_price);
      let onlineBrokerageRate = 0;

      if (grossAmount <= 100000) {
        onlineBrokerageRate = brokerage_under_rate;
      } else if (grossAmount > 100000) {
        onlineBrokerageRate = brokerage_over_rate;
      }

      let brokerage = _.round(grossAmount * (onlineBrokerageRate / 100), 2);

      brokerage = Math.abs(brokerage) < min_brokerage ? min_brokerage : Math.abs(brokerage);
      let clearingFee = (grossAmount * parseFloat(clearing_fee_rate)) / 100;
      clearingFee =
        clearingFee > parseFloat(max_clearing_fee) ? parseFloat(max_clearing_fee) : _.round(clearingFee, 2);
      clearingFee = Math.abs(clearingFee);

      const regex = /\((\d+)\)/;
      let stockCode = regex.exec(stock_code);
      if (stockCode) stockCode = stockCode[1];
      let isWarrant = stockCode && stockCode.length > 4;
      let stampDutyPercentage = isWarrant ? STAMP_DUTY_WARRANT : STAMP_DUTY;
      let stampDutyMax = isWarrant ? STAMP_DUTY_WARRANT_MAX : STAMP_DUTY_MAX;
      let stampDuty = Math.abs(grossAmount) / 1000;
      let stampDutyCharge = 10 * stampDutyPercentage;

      stampDuty =
        stampDuty % 1 == 0
          ? parseInt(stampDuty) * stampDutyCharge
          : parseInt(stampDuty) * stampDutyCharge + stampDutyCharge;

      let finalStampDuty = stampDuty > stampDutyMax ? stampDutyMax : stampDuty;
      finalStampDuty = Math.abs(finalStampDuty);

      let sstAmount = _.round(brokerage * sst, 2);

      sstAmount = Math.abs(sstAmount);

      osAmount =
        parseFloat(grossAmount) +
        parseFloat(brokerage) +
        parseFloat(clearingFee) +
        parseFloat(finalStampDuty) +
        parseFloat(sstAmount);
      osAmount = _.ceil(osAmount, 2) * -1;

      return osAmount;
    }
  };
  const action_type = watch("action_type");

  useEffect(() => {
    if (!isEdit) {
      setValue("stock_quantity", "");
      setValue("stock_price", "");
      setValue("stock_code", "");
      setValue("stock_name", "");
      setValue("stock_mof", "");
      setValue("stock_cap_price", "");
      setValue("margin_amount", "");
      setValue("amount", "");
    }
  }, [action_type]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Add New Movement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="setoff-modal-label mb-3">
          <div>
            <Form.Label>Type</Form.Label>
          </div>
          <Form.Select
            size="lg"
            className="setoff-select-duedate"
            {...register(`action_type`, {
              onChange: (e) => {
                setValue("action_type", e.target.value);
              },
            })}
          >
            <option value={0}>Please select action</option>
            {actionData.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        {action_type === Constants.TRANSFER_IN || action_type === Constants.TRANSFER_OUT ? (
          <>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Stock Code</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_code", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Stock Name</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_name", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Quantity (x100)</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_quantity", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Price</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_price", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>MOF (%)</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_mof", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Cap Price</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_cap_price", { required: true })}
                />
              </div>
            </Form.Group>
          </>
        ) : (
          false
        )}

        {(action_type === Constants.BUY_IN || action_type === Constants.SELL_OUT) && (
          <>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Stock Code</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_code", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Stock Name</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_name", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Quantity x100</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_quantity", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Price</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_price", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>MOF (%)</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_mof", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Cap Price</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  className="custom-setoff-datepicker-white"
                  {...register("stock_cap_price", { required: true })}
                />
              </div>
            </Form.Group>
            <Form.Group className="setoff-modal-label mb-3">
              <div>
                <Form.Label>Margin Amount</Form.Label>
                <Form.Control
                  // value={partAmt}
                  // onChange={(e) => setPartAmt(e.target.value)}
                  // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                  type="input"
                  readOnly
                  className="custom-setoff-datepicker-white"
                  {...register("margin_amount", { required: true })}
                />
              </div>
            </Form.Group>
          </>
        )}

        {action_type === Constants.BUY_IN ||
        action_type === Constants.SELL_OUT ||
        action_type === Constants.CASH_OUT ||
        action_type === Constants.CASH_IN ? (
          <Form.Group className="setoff-modal-label mb-3">
            <div>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                // value={partAmt}
                // onChange={(e) => setPartAmt(e.target.value)}
                // style={{ backgroundColor: partAmt.length > 0 ? "#D9D9D9" : "white" }}
                type="input"
                readOnly={action_type === Constants.BUY_IN || action_type === Constants.SELL_OUT}
                className="custom-setoff-datepicker-white"
                {...register("amount", { required: true })}
              />
            </div>
          </Form.Group>
        ) : (
          false
        )}
        <div className="d-flex justify-content-end my-3 mr-3">
          <button className={clsx("btn custom-button-back")} onClick={handleClose}>
            Cancel
          </button>
          <button
            className={clsx("btn custom-button-primary")}
            type="submit"
            disabled={action_type === 0}
            style={{ backgroundColor: "#9D7905" }}
            onClick={handleSubmit}
          >
            Confirm
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddNewMargin;
